import {
  Button,
  Dialog,
  Grid,
  Typography,
  useMediaQuery,
  Box,
} from '@mui/material';
import { ExpandLessOutlined, ExpandMoreOutlined } from '@mui/icons-material';
import 'index.css';
import React, { useState, useEffect } from 'react';
import { poppins500, poppins400 } from 'theme/common.style';
import PrivateOfferSpinner from './PrivateOfferSpinner';
import { Pendingwarning } from 'component/BuyersMarketplace/MakeOffers';
import { useTheme } from '@emotion/react';
import { postApiCall } from 'api/apiService';
import { BUYER_ACTION_PRIVATE } from 'constant/app.config';
import Swal from 'sweetalert2';
import PrivateOfferCancel from './PrivateOfferCancel';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import Loading from 'assets/images/loading.png';

dayjs.extend(utc);
dayjs.extend(timezone);

const PrivateOfferAcceptPopupTwo = ({
  open,
  onClose,
  getBuyerIndividualValue,
  PopupOneClose,
  setManageOffer,
  groupIt,
  groupCall,
}) => {
  const theme = useTheme();
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches500 = useMediaQuery(theme.breakpoints.down(500));
  const matches600 = useMediaQuery(theme.breakpoints.down(600));
  const matches750 = useMediaQuery(theme.breakpoints.down(750));
  const matches800 = useMediaQuery(theme.breakpoints.down(850));
  const isSmallHeight = useMediaQuery('(max-height:700px)');
  const sydneyDateTime = dayjs()
    .tz('Australia/Sydney')
    .format('HH:mm:ss DD MMMM YYYY');
  const [showOfferSummary, setShowOfferSummary] = useState(true);
  const [confirmCancel, setConfirmCancel] = useState(false);
  const handleToggle = () => {
    setShowOfferSummary((prev) => !prev);
  };
  const flexStyle = { display: 'flex', alignItems: 'center', gap: '15px' };
  const reqStyle = {
    fontFamily: 'poppins',
    color: '#666666',
    whiteSpace: matches600 ? 'nowrap' : 'wrap',
    fontSize: matches750 ? '14px' : '16px',
    width: '30%',
  };

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleBuyerActionPrivate = async () => {
    const rawPrice =
      getBuyerIndividualValue?.PropertyDetails?.privateOfferDetails
        ?.privateOfferPrice;

    const vendorOfferPrice = rawPrice
      ? Number(rawPrice.replace(/\$/g, '').replace(/,/g, ''))
      : null;

    const payload = {
      propertyId:
        getBuyerIndividualValue?.PropertyDetails?.property?.propertyId,
      vendorOfferPrice,
      buyerStatus: 'Accepted',
    };

    try {
      setIsSubmitting(true);
      const response = await postApiCall(BUYER_ACTION_PRIVATE, payload);

      if (response?.data?.status == 1) {
        onClose();
        PopupOneClose();
        setManageOffer(false);
        Swal.fire({
          title: response?.data?.heading,
          text: response?.data?.message,
          icon: 'success',
          confirmButtonText: 'Close',
        }).then(() => {
          groupIt();
          groupCall();
        });
      } else {
        onClose();
        PopupOneClose();
        setManageOffer(false);
        Swal.fire({
          title: response?.data?.heading,
          text: response?.data?.message,
          icon: 'error',
          confirmButtonText: 'Close',
        }).then(() => {
          groupIt();
          groupCall();
        });
      }
    } catch (error) {
    } finally {
      setIsSubmitting(false);
    }
  };

  const [countdown, setCountdown] = useState(10);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    if (isPaused || !open) return;

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          setIsPaused(true);
          handleBuyerActionPrivate();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [isPaused, open]);

  useEffect(() => {
    if (!open) {
      setCountdown(10);
      setIsPaused(false);
    }
  }, [open]);

  const [offerAcceptedTime, setOfferAcceptedTime] = useState('');

  useEffect(() => {
    if (open) {
      const nowSydney = dayjs().tz('Australia/Sydney');
      const acceptedTime = nowSydney
        .add(10, 'second')
        .format('HH:mm:ss DD MMMM YYYY');

      setOfferAcceptedTime(acceptedTime);
    }
  }, [open]);

  return (
    <>
      <Dialog
        open={open}
        PaperProps={{
          sx: {
            height: 'auto',
            borderRadius: '8px',
            boxShadow: '-4px 4px 8px rgba(0, 0, 0, 0.09)',
            padding: matchesmd ? '30px 20px' : '30px',
            minWidth: matches800 ? '95%' : '721px',
          },
        }}
      >
        <Grid container>
          <Grid item>
            <Typography
              sx={{
                fontFamily: 'poppins!important',
                fontSize: matchesmd ? '10px' : '14px!important',
                fontWeight: 400,
                color: '#666666',
              }}
            >
              {
                getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                  ?.streetName
              }
            </Typography>

            <Grid
              item
              display={'flex'}
              alignItems={'center'}
              padding={'12px 0px 15px 0'}
            >
              <Pendingwarning matchesmd={matchesmd} />
              <Typography
                sx={{
                  ...poppins500,
                  fontSize: matchesmd ? '16px' : '24px',
                  paddingLeft: '12px',
                  color: '#000000',
                }}
              >
                Private Offer Acceptance
              </Typography>
            </Grid>

            <Grid>
              <Typography
                sx={{
                  paddingTop: '8px',
                  fontFamily: 'poppins!important',
                  fontSize: matchesmd ? '12px' : '16px!important',
                  fontWeight: 400,
                  color: '#666666',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                You have accepted the{' '}
                <Box
                  component="span"
                  sx={{
                    fontFamily: 'poppins!important',
                    fontSize: matchesmd ? '12px' : '16px!important',
                    fontWeight: 600,
                    color: '#666666',
                  }}
                >
                  Private Offer
                </Box>{' '}
                of{' '}
                <Box
                  component="span"
                  sx={{
                    fontFamily: 'poppins!important',
                    fontSize: matchesmd ? '12px' : '16px!important',
                    fontWeight: 600,
                    color: '#666666',
                  }}
                >
                  {' '}
                  {getBuyerIndividualValue?.PropertyDetails?.privateOfferDetails
                    ?.privateOfferPrice
                    ? getBuyerIndividualValue.PropertyDetails
                        .privateOfferDetails.privateOfferPrice
                    : '-'}{' '}
                </Box>{' '}
                at{' '}
                <Box
                  component="span"
                  sx={{
                    fontFamily: 'poppins!important',
                    fontSize: matchesmd ? '12px' : '16px!important',
                    fontWeight: 600,
                    color: '#666666',
                  }}
                >
                  {' '}
                  {offerAcceptedTime}.
                </Box>
              </Typography>
            </Grid>
            <Grid container spacing={2} sx={{ p: '30px 0px' }}>
              <Grid item xs={12}>
                <Box
                  display="flex"
                  flexDirection="row"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Typography
                    sx={{
                      fontFamily: 'Poppins',
                      fontSize: '24px',
                      fontWeight: 400,
                      color: '#000000',
                    }}
                  >
                    Offer Summary
                  </Typography>
                  <Typography
                    onClick={handleToggle}
                    sx={{
                      border: '1px solid #F0F0F0',
                      padding: '5px 6px',
                      height: '41px',
                      width: '41px',
                      display: 'flex',
                      alignItems: 'center',
                      borderRadius: '5px',
                      cursor: 'pointer',
                    }}
                  >
                    {showOfferSummary ? (
                      <ExpandLessOutlined sx={{ color: '#0065FC' }} />
                    ) : (
                      <ExpandMoreOutlined sx={{ color: '#0065FC' }} />
                    )}
                  </Typography>
                </Box>
              </Grid>

              {showOfferSummary && (
                <Grid container item xs={12} sx={{ alignItems: 'flex-start' }}>
                  <Grid item xs={12} sm={8}>
                    <Grid
                      xs={12}
                      sx={{
                        ...flexStyle,
                        flexDirection: matches500 ? 'column' : 'row',
                        flexWrap: matches600 ? 'wrap' : 'nowrap',
                        alignItems: matches500 ? 'flex-start' : 'center',
                        mb: 5,
                      }}
                    >
                      <Typography
                        sx={{
                          ...reqStyle,
                          width: matches500 ? '100%' : '30%',
                          mb: matches500 ? '8px' : 0,
                          textAlign: matches500 ? 'start' : 'left',
                          color: '#666666',
                          fontWeight: 400,
                        }}
                      >
                        Price:
                      </Typography>
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: matches500 ? 'column' : 'row',
                          alignItems: matches500 ? 'flex-start' : 'center',
                          gap: '10px',
                          width: matches500 ? '100%' : 'auto',
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: 'Poppins',
                            fontSize: matches800 ? '12px' : '16px',
                            color: '#000000',
                            fontWeight: 400,
                          }}
                        >
                          {getBuyerIndividualValue?.PropertyDetails
                            ?.privateOfferDetails?.privateOfferPrice
                            ? getBuyerIndividualValue.PropertyDetails
                                .privateOfferDetails.privateOfferPrice
                            : '-'}
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid
                      xs={12}
                      sx={{
                        ...flexStyle,
                        flexDirection: matches500 ? 'column' : 'row',
                        flexWrap: matches600 ? 'wrap' : 'nowrap',
                        alignItems: matches500 ? 'flex-start' : 'center',
                        mb: 5,
                      }}
                    >
                      <Typography
                        sx={{
                          ...reqStyle,
                          width: matches500 ? '100%' : '30%',
                          mb: matches500 ? '8px' : 0,
                          textAlign: matches500 ? 'start' : 'left',
                          fontWeight: 400,
                          color: '#666666',
                        }}
                      >
                        Offer Status:
                      </Typography>
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: matches500 ? 'column' : 'row',
                          alignItems: matches500 ? 'flex-start' : 'center',
                          gap: '10px',
                          width: matches500 ? '100%' : 'auto',
                        }}
                      >
                        <Typography
                          sx={{
                            display: 'flex',
                            width: '95px',
                            padding: '3px 6px',
                            alignItems: 'flex-start',
                            justifyContent: 'center',
                            gap: '10px',
                            borderRadius: '5px',
                            background:
                              getBuyerIndividualValue?.PropertyDetails
                                ?.privateOfferDetails?.isConditional == 1
                                ? 'rgba(237, 11, 11, 0.60)'
                                : '#10D35E',
                            marginTop: '-2px',
                          }}
                        >
                          <Typography
                            sx={{
                              color: '#FFF',
                              fontFamily: 'Poppins',
                              fontSize: '10px',
                              fontStyle: 'normal',
                              fontWeight: 500,
                              lineHeight: 'normal',
                              textTransform: 'capitalize',
                            }}
                          >
                            {getBuyerIndividualValue?.PropertyDetails
                              ?.privateOfferDetails?.isConditional == 1
                              ? 'Conditional'
                              : 'Unconditional'}
                          </Typography>
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid
                      xs={12}
                      sx={{
                        ...flexStyle,
                        flexDirection: matches500 ? 'column' : 'row',
                        flexWrap: matches600 ? 'wrap' : 'nowrap',
                        alignItems: matches500 ? 'flex-start' : 'center',
                        mb: 5,
                      }}
                    >
                      <Typography
                        sx={{
                          ...reqStyle,
                          width: matches500 ? '100%' : '30%',
                          mb: matches500 ? '8px' : 0,
                          textAlign: matches500 ? 'start' : 'left',
                          color: '#666666',
                          fontWeight: 400,
                        }}
                      >
                        Deposit:
                      </Typography>
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: matches500 ? 'column' : 'row',
                          alignItems: matches500 ? 'flex-start' : 'center',
                          gap: '10px',
                          width: matches500 ? '100%' : 'auto',
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: 'Poppins',
                            fontSize: matches800 ? '12px' : '16px',
                            color: '#000000',
                            fontWeight: 400,
                          }}
                        >
                          {`${getBuyerIndividualValue?.PropertyDetails?.privateOfferDetails?.depositAmount}%`}
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid
                      xs={12}
                      sx={{
                        ...flexStyle,
                        flexDirection: matches500 ? 'column' : 'row',
                        flexWrap: matches600 ? 'wrap' : 'nowrap',
                        alignItems: matches500 ? 'flex-start' : 'center',
                      }}
                    >
                      <Typography
                        sx={{
                          ...reqStyle,
                          width: matches500 ? '100%' : '30%',
                          mb: matches500 ? '8px' : 0,
                          textAlign: matches500 ? 'start' : 'left',
                          color: '#666666',
                          fontWeight: 400,
                        }}
                      >
                        Settlement:
                      </Typography>
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: matches500 ? 'column' : 'row',
                          alignItems: matches500 ? 'flex-start' : 'center',
                          gap: '10px',
                          width: matches500 ? '100%' : 'auto',
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: 'Poppins',
                            fontSize: matches800 ? '12px' : '16px',
                            color: '#000000',
                            fontWeight: 400,
                          }}
                        >
                          {getBuyerIndividualValue?.PropertyDetails
                            ?.privateOfferDetails?.settlementDays !== undefined
                            ? `${
                                getBuyerIndividualValue?.PropertyDetails
                                  ?.privateOfferDetails?.settlementDays
                              } ${
                                Number(
                                  getBuyerIndividualValue?.PropertyDetails
                                    ?.privateOfferDetails?.settlementDays
                                ) === 1
                                  ? 'day'
                                  : 'days'
                              }`
                            : '-'}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>

          <Grid container>
            <Box sx={{ mx: '-30px' }}>
              <Typography
                sx={{
                  border: '1px solid #D9D9D9',
                  width: 'calc(100% + 720px)',
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
              ></Typography>
            </Box>
          </Grid>
          <Grid
            container
            sx={{
              padding: '40px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: 'auto',
            }}
          >
            <PrivateOfferSpinner
              isSmallHeight={isSmallHeight}
              isPaused={isPaused}
            />
          </Grid>
          <Grid
            container
            marginTop={matchessm ? '30px' : '20px'}
            justifyContent={'flex-end'}
            alignItems={'center'}
            gap={'20px'}
          >
            <Grid item>
              <Typography
                sx={{ ...poppins400, fontSize: '14px', color: '#6C2AD2' }}
              >
                {countdown} seconds
              </Typography>
            </Grid>
            <Grid item>
              <Box display="flex" alignItems="center" gap="10px">
                <Button
                  variant="outlined"
                  style={{
                    padding: '10px 39px',
                    height: '41px',
                    fontSize: matchesmd ? '12px' : '14px',
                    color: '#666666',
                    fontWeight: '400',
                    fontFamily: 'Poppins',
                    borderRadius: '5px',
                    textTransform: 'none',
                  }}
                  onClick={() => {
                    setConfirmCancel(true);
                    setIsPaused(true);
                  }}
                  disabled={isSubmitting}
                >
                  Cancel
                </Button>

                {isSubmitting && (
                  <img
                    alt="Loading"
                    src={Loading}
                    className="loaderImage"
                    style={{ height: '35px', width: '35px' }}
                  />
                )}
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>
      <PrivateOfferCancel
        confirmCancel={confirmCancel}
        setConfirmCancel={setConfirmCancel}
        getBuyerIndividualValue={getBuyerIndividualValue}
        isSmallHeight={isSmallHeight}
        matchessm={matchessm}
        matchesmd={matchesmd}
        PopupTwoOpen={open}
        setIsPaused={setIsPaused}
        onClose={onClose}
        setManageOffer={setManageOffer}
        groupIt={groupIt}
        groupCall={groupCall}
      />
    </>
  );
};
export default PrivateOfferAcceptPopupTwo;
